import {utils} from "@mc/mc-legacy";
const {ErrorApi, ParamsFetch} = utils;

/**
 * Ručně psané API z důvodu nevygenerovatelného @RequestPart
 */
export default class CiselnikCustomApi {

    static nactiSouborStrediska(spolecnostId, obsahujeHlavicku, orezStrediskoKod, orezStrediskoNazev, oddelovac, soubor) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/nactisoubor`;
        const headers = new Headers();
        headers.append("Content-Type", undefined); // Aby automaticky nastavil content kvůli boundary
        const params = { spolecnostId, obsahujeHlavicku, orezStrediskoKod, orezStrediskoNazev, oddelovac };
        const data = new FormData();
        data.append("soubor", soubor);

        return ErrorApi.responseResolver(ParamsFetch.put(uri, params, data, headers));
    }

    static testSouborStrediska(spolecnostId, obsahujeHlavicku, oddelovac, soubor) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/testsoubor`;
        const headers = new Headers();
        headers.append("Content-Type", undefined); // Aby automaticky nastavil content kvůli boundary
        const params = { spolecnostId, obsahujeHlavicku, oddelovac };

        const data = new FormData();
        data.append("soubor", soubor);

        return ErrorApi.responseResolver(ParamsFetch.put(uri, params, data, headers));
    }

}
